import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import { useAppContext } from "../context/AppContext";

const Layout = (props) => {
  const { isDefaultValuesLoading } = useAppContext();
  return (
    <>
      <div className="settings-wrapper">
        <div className={`layout-container ${isDefaultValuesLoading ? "loading" : ""}`}>
          <Header logo="assets/Elysia-logo.svg" title={props.title} message="Outlook Assistant" />
          <Outlet />
        </div>
      </div>
      {isDefaultValuesLoading && (
        <div className="layout-loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
    </>
  );
};

export default Layout;
